<template>
    <div>
        <div v-if="loading" class="mt-5 mb-5">
            <spinner position="center"></spinner>
        </div>
        <form v-if="client" v-show="!loading" id="filesForm" ref="filesForm" method="POST"
              class="ang-card-body"
              :action="action">
            <input type="hidden" name="data[step_6]" value="1" />
            <input type="hidden" name="code" :value="code" />
            <div>
                <div class="row">
                    <div class="col-12">
                        <p class="ang-card-title mt-3">Załącz oryginały lub skany/zdjęcia oryginałów</p>
                    </div>
                </div>
                <div class="row" v-if="client.files_note">
                    <div class="col-12 mb-4">
                        Notatka od eksperta ANG:
                        <div class="font-italic">
                            {{client.files_note}}
                        </div>
                    </div>
                </div>
                <div class="row">
                <div class="col-12">
                    <uploader upload_url="client/files" :atts="client.attachments" :base="base" :code="code" @uploadSuccess="uploadSuccess"></uploader>
                </div>

            </div>
            </div>
          <div class="row" >
            <div class="col-12 col-md-4">
              <div class="form-group">
                <label class="ang-form-label">Notatka dla eksperta</label>
                <textarea type="text" class="ang-form-control" name="client_note" rows="5"
                          v-model="client.client_note"></textarea>
              </div>
            </div>
          </div>
            <div class="alert alert-danger ang-alert-danger mt-3" v-if="error">
                <h5 class="ang-card-title">Wystąpił błąd!</h5>
                <label class="form-error error">{{error}}</label>
            </div>
            <div class="d-flex align-items-end flex-column">
                <spinner v-if="sending"></spinner>
                <button v-else type="submit" class="btn btn-lg  ang-button ang-btn-lg spinn">Zakończ</button>
            </div>
        </form>
    </div>
</template>

<script>
import ajax from '@/services/ajax'
import api from '@/services/api'
import dictionary from '@/services/dictionary'
import spinner from "@/components/partials/misc/spinner"
import uploader from "@/components/partials/misc/uploader"
import $ from 'jquery'

export default {
  data () {
    return {
      success: false,
      error: null,
      sending: false,
      loading: true,
      client: null
    }
  },
  props: ['base_client', 'base', 'code'],
  components: {
    spinner,
    uploader
  },
  mixins: [dictionary],
  watch: {
    base_client () {
      let self = this
      this.client = this.base_client
      this.$nextTick(function () {
        self.loading = false
      })
    },
  },
  name: 'filesBucket',
  computed: {
    action () {
      return '/client/details/' + this.base
    }
  },
  mounted () {
    let self = this
    this.client = this.base_client
    this.$nextTick(function () {
      self.loading = false
      ajax.postValidate($(self.$refs.filesForm), self, function () {
        self.sending = false
        self.$emit('forward', self.client)
      }, function (data) {
        self.error = data.message
        self.sending = false
        $('html,body').animate({scrollTop: $(document).height()}, 'slow')
      }, function () {
        self.error = null
        self.sending = true
      })
    })
  },
  methods: {
    uploadSuccess () {
      let self = this
      this.$nextTick(function () {
        let params = $(self.$refs.filesForm).serializeArray()
        params.push({name: 'preventNotification', value: true})
        api.post(this.action, params, function (data) {
          console.log(data)
        })
      })
    },
    refreshForm () {
      this.$forceUpdate()
    }
  }
}

</script>

